module.exports = __webpack_public_path__ + "static/logo-circle-d081f4abb79c0e232ec7e247bc880fe8.png";